export const rawUrl = 'https://api.diegotrainer.com/'
// export const rawUrl = 'http://192.168.0.2:4000/';